var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule1IconRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    sodipodidocname: "module1_icon_red.svg",
    inkscapeversion: "1.2.1 (9c6d41e4, 2022-07-14)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs90"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview88",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeshowpageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    inkscapedeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapezoom: 0.64187501,
    inkscapecx: -25.705939,
    inkscapecy: 703.40797,
    "inkscapewindow-width": 2699,
    "inkscapewindow-height": 1205,
    "inkscapewindow-x": 0,
    "inkscapewindow-y": 25,
    "inkscapewindow-maximized": 0,
    "inkscapecurrent--layer": "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3355",
    transform: "matrix(0.77635418,0,0,0.77635418,-530.34623,138.94719)",
    inkscapelabel: "icon",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    fill: "#ff0000",
    d: "m 1166.6583,73.706698 c -1.361,-1.877182 -3.0622,-3.441501 -5.4438,-3.441501 l -80.6363,-0.625727 v 0 c -1.7012,0 -3.7426,1.251455 -5.1036,2.190046 -1.3609,1.251455 -1.3609,3.441501 -0.6805,5.318683 l 8.1657,20.336143 c -5.4438,-1.251455 -11.2278,-1.251455 -17.3521,-1.251455 -13.6095,0 -28.5799,2.190047 -43.5504,7.508733 -25.51781,8.76018 -45.93207,23.15191 -57.50014,40.04656 -1.36095,1.87718 -1.36095,3.4415 -0.68048,4.69295 l 19.0533,50.0582 h -26.53853 v -62.25988 c 0,-2.81578 -2.38166,-5.94441 -6.12427,-5.94441 h -33.34329 c -14.28997,0 -27.89948,7.50872 -34.02375,19.71041 l -15.65093,27.21915 c -6.12428,10.95023 -9.18642,23.77764 -9.18642,35.97933 v 39.42083 c 0,2.81577 2.38167,5.94441 6.12428,5.94441 h 16.67164 c 5.4438,12.20168 18.03259,20.33614 32.32257,20.33614 14.28998,0 27.21901,-8.76018 32.32257,-20.33614 h 64.30495 c 5.4438,12.20168 18.0325,20.33614 32.3225,20.33614 14.29,0 27.219,-8.76018 32.3226,-20.33614 h 25.5178 c 3.0622,0 6.1243,-2.19005 6.1243,-5.94441 v -39.42083 c 0,-2.81578 -2.3817,-5.94441 -6.1243,-5.94441 h -29.6007 v -4.69296 c 6.8048,-2.81577 12.9291,-6.25728 19.0533,-10.01164 l 26.1983,20.96187 c 1.361,1.25145 2.3817,1.25145 3.7427,1.25145 0,0 0,0 0.6804,0 1.7012,0 3.0622,-0.62572 4.4231,-1.87718 l 15.9912,-18.14609 c 2.3816,-2.19005 1.7012,-5.94442 -0.6805,-8.13446 l -22.7959,-18.45896 c 0.6805,-1.25146 1.3609,-1.87718 1.7012,-2.81578 1.3609,-1.87718 1.3609,-3.4415 0.6805,-4.69295 l -9.1865,-23.77765 55.1185,-58.192652 c 2.3817,-1.877182 3.0622,-4.067229 1.7012,-5.944411 z M 1107.1167,162.56 c -1.7012,2.81577 -4.4231,5.31868 -6.8048,8.13446 -3.0621,2.81577 -6.1242,5.94441 -9.8668,8.13445 -1.7012,1.87719 -4.4231,2.81578 -6.1243,4.69296 l -5.1036,-14.07887 v 0 l -6.1243,-17.52037 -5.1035,-12.20168 -11.9083,-32.53783 c 11.2278,-1.25146 21.7752,0 30.9616,2.19004 l 19.0533,51.30966 0.6805,1.87718 z m -48.3137,96.04917 c -3.7426,4.69295 -9.8669,7.50873 -16.6717,7.50873 -6.8047,0 -12.929,-2.81578 -16.6716,-7.50873 -2.3817,-2.81578 -4.4231,-6.883 -5.1036,-10.95023 0,-0.62573 0,-0.62573 0,-1.25146 0,-1.25145 0,-2.81577 0.6805,-4.06723 0,-0.62572 0.6805,-1.25145 0.6805,-1.87718 2.3816,-8.13446 11.2278,-14.07887 20.4142,-14.07887 9.8669,0 18.0326,5.94441 20.4143,14.07887 0,0.62573 0.6805,1.25146 0.6805,1.87718 0,1.25146 0.6804,2.81578 0.6804,4.06723 0,0.62573 0,0.62573 0,1.25146 -0.6804,4.06723 -1.7012,8.13445 -5.1035,10.95023 z M 996.87973,128.45785 c 0.68047,-0.62572 1.70118,-1.25145 2.38166,-1.87718 l 26.53851,71.95866 1.361,3.4415 c -11.2279,1.25146 -21.7752,0 -30.96165,-2.19004 l -0.68047,-1.25146 -19.73378,-51.30965 c 5.4438,-6.88301 12.24855,-13.45314 21.09473,-19.08469 z m 57.15987,-20.33614 12.2486,33.78928 4.4231,12.20169 5.1035,12.82741 6.1243,17.52037 c -0.6805,0.62573 -1.3609,0.62573 -1.7012,1.25146 -6.8047,4.06723 -14.9704,7.50873 -22.7959,10.3245 -3.0621,1.25146 -6.1243,1.87718 -9.1864,2.81577 -6.1243,1.87719 -12.929,2.81578 -19.0533,3.44151 l -1.361,-3.44151 -27.219,-73.21011 c 7.4853,-4.69296 15.9912,-8.76019 24.8374,-11.57596 10.5473,-2.81577 19.7338,-4.69296 29.2604,-5.94441 z m 37.7664,-20.336143 h 50.3552 l -35.3847,37.230783 z m 52.0564,-1.877183 h -52.7369 l -1.7012,-5.318684 58.8611,0.625728 z m -265.72559,96.674896 15.65093,-27.21915 c 4.42309,-8.13445 13.6095,-13.45314 23.47639,-13.45314 h 27.21901 v 70.39435 c 0,2.81577 2.38166,5.94441 6.12427,5.94441 l 72.47059,0.62572 c -8.1657,4.69296 -13.6095,12.82742 -15.6509,21.5876 h -60.90254 c -3.06213,-15.01746 -17.35211,-27.21914 -34.70423,-27.21914 -17.35212,0 -31.64209,11.57595 -34.70423,27.21914 h -8.1657 v -26.90628 c 0,-10.3245 3.06213,-20.96187 8.84617,-30.97351 z m 51.37587,76.02589 c -3.74261,4.69295 -9.86689,7.50873 -16.67164,7.50873 -6.80475,0 -12.92902,-2.81578 -16.67164,-7.50873 -2.38166,-2.81578 -4.42309,-6.883 -5.10356,-10.95023 0,-0.62573 0,-0.62573 0,-1.25146 0,-1.25145 0,-2.81577 0.68047,-4.06723 0,-0.62572 0.68048,-1.25145 0.68048,-1.87718 2.38166,-8.13446 11.22784,-14.07887 20.41425,-14.07887 9.18642,0 18.03259,5.94441 20.41426,14.07887 0,0.62573 0.68047,1.25146 0.68047,1.87718 0,1.25146 0.68048,2.81578 0.68048,4.06723 0,0.62573 0,0.62573 0,1.25146 -0.68048,4.06723 -2.38166,8.13445 -5.10357,10.95023 z m -60.22205,-10.95023 v -5.31869 h 8.1657 c 0,1.25146 0,2.81578 0,4.06723 0,0.62573 0,0.62573 0,1.25146 z m 78.59488,0 c 0,-0.62573 0,-0.62573 0,-1.25146 0,-1.25145 0,-2.81577 0,-4.06723 h 60.22209 c 0,1.25146 0,2.81578 0,4.06723 0,0.62573 0,0.62573 0,1.25146 z m 129.63049,0 c 0,-0.62573 0,-0.62573 0,-1.25146 0,-1.25145 0,-2.81577 0,-4.06723 h 17.3521 v 5.31869 z m 16.6717,-28.4706 v 20.96187 h -17.3521 c -1.7012,-8.76019 -7.4853,-16.26892 -14.9705,-21.5876 z m 33.3433,-26.28056 -8.8462,9.38592 -19.0533,-15.64319 c 3.7426,-2.81578 6.8047,-5.31869 9.1864,-8.13446 z",
    className: "st1",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.26264,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    fill: "#ff0000",
    d: "m 926.79078,240.15021 c -2.38166,-5.31869 -8.1657,-8.76019 -14.28997,-8.76019 -6.12428,0 -11.90832,3.4415 -14.28998,8.76019 0,0.62573 -0.68048,1.25145 -0.68048,1.87718 -0.68047,1.25146 -0.68047,2.19005 -0.68047,4.06723 0,0.62573 0,0.62573 0,1.25145 0.68047,4.69296 3.06214,8.76019 7.48522,10.95023 2.38167,1.25146 5.10357,2.19005 8.16571,2.19005 3.06213,0 5.4438,-0.62573 8.1657,-2.19005 4.42309,-2.19004 6.80475,-6.25727 7.48522,-10.95023 0,-0.62572 0,-0.62572 0,-1.25145 0,-1.25146 0,-2.81577 -0.68047,-4.06723 0,0 0,-1.25145 -0.68048,-1.87718 z m -11.90831,18.45896 h -4.42309 c -6.12428,-1.25146 -10.54736,-5.31869 -11.22784,-10.95023 0,-0.62573 0,-0.62573 0,-1.25146 0,-1.25145 0,-2.81577 0.68048,-4.06723 0,-0.62572 0.68047,-1.25145 0.68047,-1.87718 2.38166,-4.06723 6.80475,-6.883 11.90832,-6.883 5.10356,0 9.86689,2.81577 11.90831,6.883 0.68048,0.62573 0.68048,1.25146 0.68048,1.87718 0.68047,1.25146 0.68047,2.19005 0.68047,4.06723 0,0.62573 0,0.62573 0,1.25146 0,5.94441 -5.10356,10.3245 -10.54736,10.95023 z",
    className: "st1",
    style: {
      stroke: "none",
      strokeWidth: 3.26264,
      strokeOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_5",
    fill: "#ff0000",
    d: "m 1056.4213,240.15021 c -2.3817,-5.31869 -8.1657,-8.76019 -14.29,-8.76019 -6.1243,0 -11.9083,3.4415 -14.29,8.76019 0,0.62573 -0.6804,1.25145 -0.6804,1.87718 -0.6805,1.25146 -0.6805,2.19005 -0.6805,4.06723 0,0.62573 0,0.62573 0,1.25145 0.6805,4.69296 3.0621,8.76019 7.4852,10.95023 2.3817,1.25146 5.1036,2.19005 8.1657,2.19005 3.0622,0 5.4438,-0.62573 8.1657,-2.19005 4.4231,-2.19004 6.8048,-6.25727 7.4853,-10.95023 0,-0.62572 0,-0.62572 0,-1.25145 0,-1.25146 0,-2.81577 -0.6805,-4.06723 0,0 0,-1.25145 -0.6805,-1.87718 z m -11.9083,18.45896 h -4.4231 c -6.1243,-1.25146 -10.5474,-5.31869 -11.2278,-10.95023 0,-0.62573 0,-0.62573 0,-1.25146 0,-1.25145 0,-2.81577 0.6804,-4.06723 0,-0.62572 0.6805,-1.25145 0.6805,-1.87718 2.3817,-4.06723 6.8048,-6.883 11.9083,-6.883 5.1036,0 9.8669,2.81577 11.9083,6.883 0.6805,0.62573 0.6805,1.25146 0.6805,1.87718 0.6805,1.25146 0.6805,2.19005 0.6805,4.06723 0,0.62573 0,0.62573 0,1.25146 0,5.94441 -5.1036,10.3245 -10.5474,10.95023 z",
    className: "st1",
    style: {
      stroke: "none",
      strokeWidth: 3.26264,
      strokeOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_6",
    fill: "#ff0000",
    d: "m 936.65767,148.794 h -20.41425 c -6.12428,0 -11.22784,2.81577 -14.97045,7.50873 l -18.0326,30.97351 H 935.9772 V 148.794 Z m -1.70118,36.60505 H 888.0037 l 15.99117,-27.84487 c 3.06213,-4.06723 7.48522,-6.25727 12.92902,-6.25727 h 18.0326 v 34.41501 z",
    className: "st1",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.26264,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1904",
    inkscapelabel: "check",
    transform: "translate(16.215948,76.167329)",
    style: {
      display: "inline",
      stroke: "#ff0000",
      strokeOpacity: 1
    },
    sodipodiinsensitive: "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.5163,8.93451 11.0597,14.7023 8.0959,11.8984",
    stroke: "#000000",
    strokeWidth: 2,
    id: "path274",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeOpacity: 1
    },
    transform: "matrix(6.2026611,0,0,6.2026611,336.61383,-11.366694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12,21 c 4.9706,0 9,-4.0294 9,-9 0,-4.97056 -4.0294,-9 -9,-9 -4.97056,0 -9,4.02944 -9,9 0,4.9706 4.02944,9 9,9 z",
    stroke: "#000000",
    strokeWidth: 2,
    id: "path276",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeOpacity: 1
    },
    transform: "matrix(6.2026611,0,0,6.2026611,336.61383,-11.366694)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2077",
    transform: "matrix(5.9989689,0,0,5.9989689,-552.11732,-210.25178)",
    inkscapelabel: "laptop",
    style: {
      display: "inline",
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2021",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    transform: "translate(92.03537,33.665402)",
    d: "m 11.066068,24.59199 c -1.7389745,0 -3.1670026,1.416933 -3.1670026,3.159918 v 18.968051 18.970968 3.159918 L -3.8839893e-7,78.336017 c 0,2.612965 2.12193658839893,4.737898 4.73789758839893,4.737898 H 80.610102 c 2.61297,0 4.737898,-2.125933 4.737898,-4.737898 l -7.898024,-9.48413 V 65.691969 46.719959 32.183294 c -0.241575,0.04561 -0.483976,0.08645 -0.728458,0.113353 -0.524534,0.06597 -1.049492,0.129019 -1.575271,0.184198 -0.02853,0.01716 -0.05657,0.03516 -0.08522,0.05209 -0.229321,0.137905 -0.471583,0.250861 -0.718249,0.353602 -0.166675,0.07517 -0.335969,0.14478 -0.50717,0.208994 -0.141673,0.05247 -0.287215,0.09316 -0.435492,0.121688 l -0.06564,0.01042 c -0.118808,0.01871 -0.229381,0.0254 -0.33339,0.02375 v 30.010574 c 0,1.524985 -1.242046,2.759016 -2.759016,2.759016 H 15.105929 c -1.513985,0 -2.75589,-1.245031 -2.75589,-2.759016 V 30.192952 c 0,-1.52497 1.241905,-2.759016 2.75589,-2.759016 h 47.151645 c -0.03771,-0.100305 -0.07144,-0.202059 -0.100226,-0.305677 -0.07603,-0.289496 -0.128919,-0.585099 -0.146483,-0.884319 -0.0159,-0.290704 -0.01071,-0.580917 0.02875,-0.869108 -0.0128,-0.119181 0.007,-0.243351 0.06189,-0.363395 0.02758,-0.141257 0.05821,-0.281944 0.09981,-0.419447 z m 20.989857,50.851863 h 21.233024 l 2.41604,2.895081 H 29.644052 Z m 4.301989,4.473061 h 12.644048 c 0.437,0 0.79097,0.35101 0.79097,0.78701 -0.008,0.445 -0.35497,0.794928 -0.79097,0.794928 H 36.357914 c -0.436985,0 -0.790969,-0.353928 -0.790969,-0.794928 0,-0.437 0.353984,-0.78701 0.790969,-0.78701 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2075",
    transform: "matrix(5.9989689,0,0,5.9989689,1.8731333e-6,-8.2940752)",
    inkscapelabel: "wifi",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff0000",
      strokeWidth: 0.77433,
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    d: "m 44.22498,7.8708704 c 4.988235,0 9.768176,2.1286339 13.11638,5.8307066 l 2.056621,-1.856844 C 55.52633,7.558041 49.992191,5.0995424 44.222657,5.0995424 c -5.772632,0 -11.30135,2.4577242 -15.172227,6.7451906 l 2.056621,1.856844 C 34.459126,9.994084 39.239841,7.8708704 44.22498,7.8708704 Z",
    id: "path2069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff0000",
      strokeWidth: 0.77433,
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    d: "m 55.53717,15.328445 c -2.885154,-3.194887 -7.008463,-5.026952 -11.31219,-5.026952 -4.300631,0 -8.427037,1.832065 -11.314514,5.026952 l 2.056621,1.856844 c 2.36403,-2.613365 5.739336,-4.112468 9.258667,-4.112468 3.522428,0 6.894637,1.499103 9.253247,4.112468 z",
    id: "path2071"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff0000",
      strokeWidth: 0.77433,
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    d: "m 37.025257,19.042133 2.056621,1.856844 c 2.621882,-2.906836 7.665095,-2.906836 10.28388,0 l 2.056621,-1.856844 c -1.837485,-2.034166 -4.458593,-3.197984 -7.199722,-3.197984 -2.741129,0 -5.359914,1.163818 -7.1974,3.197984 z",
    id: "path2073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule1IconRed);
export default __webpack_public_path__ + "static/media/module1_icon_red.1abc4236.svg";
export { ForwardRef as ReactComponent };